// App-level session actions for pages that end the current sign-in (password reset, two-step
// enrollment, joining a workspace): the server revoked or no longer accepts this session, so the
// workspace is cleared and the normal sign-in is required.
import { createContext, useContext } from 'react';
import type { SignOutNotice } from './session.ts';

export interface SessionActions {
  /** Ends this browser's session (stopping the phone first), clears the workspace and shows sign-in. */
  requireFreshSignIn(notice: SignOutNotice): Promise<void>;
  /** Re-reads /auth/session after the server reported a session or CSRF problem. */
  reloadSession(): Promise<void>;
}

export const SessionActionsContext = createContext<SessionActions | null>(null);

export function useSessionActions(): SessionActions | null {
  return useContext(SessionActionsContext);
}
